// Toile's sign-in overlay — board SignInOverlay: the scrim over whatever is behind it (the dimmed
// wall, or the pack page), the shipped SignInCard centered on top. One layer at a time (BRIEF § The
// v1 cut). Moved here from `styles/Wall.module.scss` by wall plan e, when the pack page's verb
// became the second surface that opens this gate.
//
// z-index: `--tl-z-signin` (products/toile/styles/index.scss — the wall's stacking order, one
// source). Must top the arena: the wall keeps the armed layer mounted while this card is up
// (`Wall.tsx` — `overlayOpen` and `signInOpen` are independent, the layer only drops its focus
// trap), so a logged-out Generate press once painted the card UNDER the sheet's own scrim and
// `touch-action: none` arena, invisible and untappable (operator-observed on a phone, 2026-09-07,
// fixed at `51b459128`).
//
// `touch-action: none`, for the reason `Sheet.module.scss` gives for its arena: a touch that begins
// on this layer must not become the browser's own pan, or the wall scrolls under the card while the
// card holds still (operator-observed on a phone, 2026-09-08 — the layer now tops the arena, so the
// arena's own rule no longer covers it). The card never scrolls internally, so nothing is lost.

.overlay {
    position: fixed;
    inset: 0;
    z-index: var(--tl-z-signin);
    touch-action: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scrim {
    position: absolute;
    inset: 0;
    background: var(--tl-scrim);
}

.card {
    position: relative;
    z-index: 1;
}
